import FrameWrapper from "components/FrameWrapper/FrameWrapper";
import { useEffect } from "react";


const FooterWrapper = () => {
	const showFooter = window.CONFIG.REACT_APP_MOSTRA_FOOTER;

	useEffect(() => {
		let app: HTMLElement = document.getElementById("app")!;
		showFooter ? app.classList.remove("app-fullheight") : app.classList.add("app-fullheight");
	});

	return (
		<>
			{showFooter && <FrameWrapper id="custom-footer" title="custom-footer" src={`${process.env.PUBLIC_URL}/customizations/footers/footer.html`} />}
		</>
	);
};
export default FooterWrapper;
